module.exports = __webpack_public_path__ + "img/fondo-region.ef23dab6.jpg";